module.exports = __webpack_public_path__ + "img/TRF-XXX.d3510e4b.png";